import styled from '@emotion/styled';
import React from 'react'
import {categories} from "../data";
import { mobile } from '../responsive';
import CategoryItem from './CategoryItem';

const Container = styled.div`
    display: flex;
    padding: 20px;
    ${mobile({padding: "0px", flexDirection: "column"})};
`;

const Categories = () => {
  return (
    <Container>
        {categories.map(item=> (
            <CategoryItem item={item} key={item.id} />
        ))};
    </Container>
  )
};

export default Categories